import { render, staticRenderFns } from "./MostUsedMedicines.vue?vue&type=template&id=18fe37aa&scoped=true&"
import script from "./MostUsedMedicines.vue?vue&type=script&lang=js&"
export * from "./MostUsedMedicines.vue?vue&type=script&lang=js&"
import style0 from "./MostUsedMedicines.vue?vue&type=style&index=0&id=18fe37aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fe37aa",
  null
  
)

export default component.exports